<template>
  <div class="content">
    페이지번호 :
    <i-input-sel v-model="list.ktype" itemsp="TITL / 제목 | ANNCPERS / 작성자"/>
    <input v-model="list.kword" />
    <button @click="doSearch">검색</button>

    <br/>
    <br/>
    총 갯수 : {{ list.totalCount }} 페이지 번호 : {{ list.pageNo }}
    <div v-for="(item,i) in list.list" :key=i @click="view(item)">
      item = {{ item }}
    </div>


----------
현재 페이지 번호 : {{ list.pageNo }}
    <s-page :pageNo.sync="list.pageNo" :totalCount="list.listTotCnt" :listSize="list.listSize" @changePage="getData"/>
------------

상세 : {{ item }}
  </div>
</template>



<script>
export default {
  data() {
    return {
      list: { },
      item: {},
    }
  },

  created() {
    this.getData();
  },

  methods: {
    doSearch() {
      this.list.pageNo = 1
      this.getData()
    },
    getData() {
      this.$ui.httpGet(
        "/sample_w/list",
        T.copyWithout(this.list, 'list'),
        ret => this.list = ret.data,
      )
    },
    view(item) {
      this.$ui.httpGet(
        "/sample_w/view",
        item,
        ret => this.item = ret.data.item,
      )
    },
  },
}
</script>